import { install } from './install'

import '@transfeeradev/components/less/transfeera.less';

class VueComponents {

  constructor(preset = {}) {
    this.framework = {};
    this.installed = [];
    this.preset = preset;

    // TODO: register services
    // this.use(services.Application)
    // this.use(services.Breakpoint)
    // this.use(services.Goto)
    // this.use(services.Icons)
  }

  init(root, ssrContext) {
    this.installed.forEach(property => {
      const service = this.framework[property];
      service.framework = this.framework;

      service.init(root, ssrContext);
    })

    this.framework.rtl = Boolean(this.preset.rtl);
  }

  use(Service) {
    const property = Service.property;

    if (this.installed.includes(property)) {
      return;
    }

    this.framework[property] = new Service(this.preset[property]);
    this.installed.push(property);
  }
}

VueComponents.install = install;
VueComponents.installed = false;

export default VueComponents;
